export { default } from './DashboardEntregas';
